import React from 'react'
import PropTypes from 'prop-types'
import { Chip } from '@material-ui/core'

import { scopeColorShape } from '../../propTypes'
import styles from './styles'

const PermissionScopeChip = ({ label, color }) => {
  const useStyles = styles(color)
  const classes = useStyles()

  return (
    <Chip
      className={classes.chip}
      classes={{ label: classes.label }}
      icon={<span className={classes.dot} />}
      label={label}
      clickable={false}
    />
  )
}

PermissionScopeChip.propTypes = {
  label: PropTypes.string.isRequired,
  color: scopeColorShape.isRequired,
}

export default PermissionScopeChip
